/**
 * @generated SignedSource<<d6a0d9c8188e0f11c41fb6a4bbcc410f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsSaveable_Routine$data = {
  readonly activeVersion: {
    readonly connections: ReadonlyArray<{
      readonly sectionId: string;
      readonly taskId: string;
    }>;
  };
  readonly isOrg: boolean;
  readonly " $fragmentType": "useIsSaveable_Routine";
};
export type useIsSaveable_Routine$key = {
  readonly " $data"?: useIsSaveable_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsSaveable_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsSaveable_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineVersion",
      "kind": "LinkedField",
      "name": "activeVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskSectionConnection",
          "kind": "LinkedField",
          "name": "connections",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sectionId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taskId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "a141a2eb875c1f34a63e60fd5cdac431";

export default node;
